// i18n-ns: allDeltas (callers pass their allDeltas-namespace `t`)
const getFrequencyLabel = (frequency, repetition, t) => {
    switch (frequency) {
        case 'week':
            return repetition > 1 ? t('serie.freqLabel.weeks') : t('serie.freqLabel.weekly');
        case 'month':
            return repetition > 1 ? t('serie.freqLabel.months') : t('serie.freqLabel.monthly');
        case 'year':
            return repetition > 1 ? t('serie.freqLabel.years') : t('serie.freqLabel.yearly');
        default:
            return '';
    }
};

export default getFrequencyLabel;
